
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6fcYF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::798e2bc618348b9cf0450d3a3e1793b1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48be35d789a94ed7$var$_react = $48be35d789a94ed7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $48be35d789a94ed7$var$_baseNew = $48be35d789a94ed7$var$_interopRequireDefault((parcelRequire("gElAV")));
function $48be35d789a94ed7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ProjectStatus".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/project-status
 * Usage guidance:
 * Reserved for representing project status in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48be35d789a94ed7$var$ProjectStatusIcon = (props)=>/*#__PURE__*/ $48be35d789a94ed7$var$_react.default.createElement($48be35d789a94ed7$var$_baseNew.default, Object.assign({
        name: "ProjectStatusIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.625A2.625 2.625 0 0 1 6.125 0h3.75A2.625 2.625 0 0 1 12.5 2.625v8.75A2.625 2.625 0 0 1 9.875 14H8.75v2h-1.5v-2H6.125A2.625 2.625 0 0 1 3.5 11.375zM6.125 1.5C5.504 1.5 5 2.004 5 2.625v8.75c0 .621.504 1.125 1.125 1.125h3.75c.621 0 1.125-.504 1.125-1.125v-8.75c0-.621-.504-1.125-1.125-1.125zM6.5 4.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$48be35d789a94ed7$var$ProjectStatusIcon.displayName = 'ProjectStatusIcon';
var $48be35d789a94ed7$var$_default = module.exports.default = $48be35d789a94ed7$var$ProjectStatusIcon;

});


//# sourceMappingURL=project-status.6ceb4740.js.map
